import React, { useState, useCallback, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ValidacionIdentificacion } from "../validations/NumerosIdentificacion.js";
import ValidationMessage from "../validations/ValidationMessage.js";
import { authService, configService } from "../services/apiService.js";

export const Login = () => {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [loginInfo, setLoginInfo] = useState(null);
  const [loginInfoLoading, setLoginInfoLoading] = useState(true);
  const [loginInfoError, setLoginInfoError] = useState("");
  const messageSpanRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    setLoginInfoLoading(true);
    setLoginInfoError("");
    configService
      .getLoginInfo()
      .then((data) => {
        if (!cancelled) {
          setLoginInfo(data);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setLoginInfoError(err.message || "Error carregant la informació");
          setLoginInfo(null);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoginInfoLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleOnChangeInputUser = useCallback((e) => {
    setUsuario(e.target.value);
    setError(""); // Limpiar error al escribir
  }, []);

  const handleOnChangeInputPassword = useCallback((e) => {
    setPassword(e.target.value);
    setError(""); // Limpiar error al escribir
  }, []);

  const handleLogin = useCallback(
    async (e) => {
      e.preventDefault();

      if (!usuario || !password) {
        setError("El NIF i la contrasenya són obligatoris");
        return;
      }

      setLoading(true);
      setError("");

      try {
        const validation =
          ValidacionIdentificacion.ComprobarNombreDocument(usuario);

        if (!validation) {
          setError("Error en iniciar sessió");
          return;
        }

        setUsuario(validation.user);

        if (validation.idValidacion === 1 || validation.idValidacion === 3) {
          // Documento válido - proceder con login sin mostrar mensaje
          await authService.login(validation.user, password);

          // Navegar después de un breve delay para mostrar feedback
          setTimeout(() => {
            navigate("/inicio", { state: { nif: validation.user } });
          }, 1000);
        } else {
          // Documento inválido - mostrar mensaje de error
          const validationMessageInstance = new ValidationMessage();
          const validationMessageText = validationMessageInstance.getMessage(
            validation.idValidacion,
          );
          setError(validationMessageText);
        }
      } catch (error) {
        console.error("Error en el login:", error);
        setError("Error en iniciar sessió");
      } finally {
        setLoading(false);
      }
    },
    [usuario, password, navigate],
  );

  return (
    <>
      <div className="form-container">
        <form id="login-form" onSubmit={handleLogin}>
          <h3>Connexió per a usuaris registrats a SGRH</h3>
          {loginInfoLoading && (
            <div className="info-login" aria-busy="true" aria-live="polite">
              <p>Carregant...</p>
            </div>
          )}
          {!loginInfoLoading && loginInfoError && (
            <div className="info-login" role="status" aria-live="polite">
              <p>Benvinguts al gestor de descàrregues de SGRH</p>
            </div>
          )}
          {!loginInfoLoading && !loginInfoError && loginInfo && (loginInfo.descripcion || (loginInfo.items && loginInfo.items.length > 0)) && (
            <div className="info-login">
              {loginInfo.descripcion && <p>{loginInfo.descripcion}</p>}
              {loginInfo.items && loginInfo.items.length > 0 && (
                <ul>
                  {loginInfo.items.map((item, index) => (
                    <li key={index}>
                      <p>{item}</p>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
          <h6>Identifica't per iniciar la sessió.</h6>
          <input
            type="text"
            id="username"
            onChange={handleOnChangeInputUser}
            placeholder="Document d'identitat"
            name="username"
            value={usuario}
            autoComplete="off"
            autoCapitalize="none"
            autoCorrect="off"
            required
          />

          <input
            type="password"
            id="password"
            placeholder="Clau"
            name="password"
            value={password}
            onChange={handleOnChangeInputPassword}
            autoComplete="off"
            autoCapitalize="none"
            autoCorrect="off"
            aria-describedby="password-error"
            required
          />

          <button
            type="submit"
            disabled={loading}
            aria-label={loading ? "Iniciant sessió..." : "Accedir al sistema"}
          >
            {loading ? "INICIANT SESSIÓ..." : "ACCEDIR"}
          </button>
          <br />
          {error && (
            <span
              ref={messageSpanRef}
              id="password-error"
              role="alert"
              aria-live="polite"
              className="error-message"
            >
              {error}
            </span>
          )}
        </form>
      </div>
    </>
  );
};
